import { shareOrigin } from "@/lib/origin";
import { useState } from "react";
import { Loader2, Send } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/apiClient";
import { Input } from "@/components/ui/input";
import { fill, shareOut } from "@/lib/partnerKit";
import { Section, Chips } from "@/components/partner/Section";

// Who + why → Adelaida records a short intro naming both, and the whole share is built for him.
export default function PersonalInvite({ k, onSent }) {
  const reasons = k.copy.invite_reasons || {};
  const [friend, setFriend] = useState("");
  const [reason, setReason] = useState("curious");
  const [busy, setBusy] = useState(false);
  const f = friend.trim().split(" ")[0];
  const preview = fill(reasons[reason]?.audio, { name: k.name, friend: f || "James" });

  const send = async () => {
    if (!f) { toast("Add your friend's first name."); return; }
    setBusy(true);
    try {
      const { data } = await api.post("/invites", { friend: f, reason });
      const url = `${shareOrigin()}${data.path}`;
      if (await shareOut({ text: data.message, url, title: `${data.friend}, a message from Adelaida` })) { setFriend(""); onSent?.(); }
    } catch (e) { toast.error(e?.response?.data?.detail || "Couldn't record the message. Please try again."); }
    finally { setBusy(false); }
  };

  return (
    <Section id="invite" eyebrow="Adelaida" title="Send a personal introduction" sub="She names you and your friend. They get a beautiful page with her voice, and a way to meet her.">
      <label className="block text-sm mb-2">Who are you sending this to?</label>
      <Input value={friend} onChange={(e) => setFriend(e.target.value)} placeholder="James" className="rounded-full max-w-xs" maxLength={30} data-testid="invite-friend-input" />
      <label className="block text-sm mt-6 mb-2">Why are you sending it?</label>
      <Chips items={Object.entries(reasons).map(([key, r]) => [key, r.label])} value={reason} onPick={setReason} testPrefix="invite-reason" />
      <div className="mt-6 rounded-3xl border border-primary/25 bg-primary/[0.05] p-6">
        <p className="text-[10px] uppercase tracking-[0.22em] text-primary mb-2">Adelaida will say</p>
        <p className="font-serif italic text-lg leading-snug" data-testid="invite-preview">"{preview}"</p>
        <button onClick={send} disabled={busy} className="mt-5 inline-flex items-center gap-2 rounded-full bg-primary text-primary-foreground px-6 py-3 text-sm font-medium disabled:opacity-60" data-testid="invite-send-btn">
          {busy ? <><Loader2 className="w-4 h-4 animate-spin" /> Adelaida is recording…</> : <><Send className="w-4 h-4" /> Create and send{f ? ` to ${f}` : ""}</>}
        </button>
      </div>
    </Section>
  );
}
